import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';

import { SharedFunctions } from '../../../../../src/app/shared/shared.functions';

import { UnidadFuncionalService, TipoUnidadService, ComunidadService,ConsorcioService, MenuFuncionService, MonedaService, TenantService } from '../../../../../src/app/shared/services';
import { Comunidad, MenuFuncionCodes, SearchComunidadRequest, Consorcio, SearchConsorcioRequest, LocalStorageKeys, TenantFeatureFlags, Moneda, SearchMonedaRequest, SaveUnidadFuncionalDto,
  SearchTipoUnidadRequest, TipoUnidad, UnidadFuncional, DialogUnidadFuncionalGestionRequestDto, DialogUnidadFuncionalGestionResponseDto
 } from '../../../../../src/app/shared/model';

@Component({
  selector: 'app-dialogUnidadFuncionalGestion',
  templateUrl: 'dialogUnidadFuncionalGestion.component.html',
  styleUrls: ['./dialogUnidadFuncionalGestion.component.css']
})

export class DialogUnidadFuncionalGestionComponent implements OnInit {

  formGroup: FormGroup;

  tenantFeatureFlags: TenantFeatureFlags;

  isValidating: boolean = false;
  isSearching: boolean = false;
  isSaving: boolean = false;
  isDeleting: boolean = false;
  isTipoGastoSearching: boolean = false;
  isConsorcioSearching: boolean = false;
  isTipoUnidadSearching: boolean = false;
  isComunidadSearching: boolean = false;
  isMonedaSearching: boolean = false;

  canEdit: boolean = false;
  canDelete: boolean = false;
  canAdd: boolean = false;
  canView: boolean = false;
  showComunidad: boolean = false;
  msgError: string = "";

  item: UnidadFuncional;

  tipoUnidadList: TipoUnidad[];
  comunidadList: Comunidad[];
  monedaList: Moneda[];
  consorcioList: Consorcio[];

  constructor(
    private dialogRef: MatDialogRef<DialogUnidadFuncionalGestionComponent>,
    @Inject(MAT_DIALOG_DATA) public input: DialogUnidadFuncionalGestionRequestDto,
    private formBuilder: FormBuilder,
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    private sharedFunctions: SharedFunctions,
    private menuService: MenuFuncionService,
    private tipoUnidadService: TipoUnidadService,
    private comunidadService: ComunidadService,
    private monedaService: MonedaService,
    private consorcioService: ConsorcioService,
    private tenantService: TenantService,
    private unidadFuncionalService: UnidadFuncionalService
  ) {

  }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenuPadre(MenuFuncionCodes.UNIDAD_FUNCIONAL).subscribe(data => {
      if (data != null && data.Success && data?.Result) {
        this.isValidating = false;
        this.tenantService.getTenantFeatureFlagsById(this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId)).subscribe(dataTenant => {
          if (dataTenant != null && dataTenant.Success) {
            this.tenantFeatureFlags = dataTenant.Result;

            this.canEdit = data.Result.some(x => x == MenuFuncionCodes.UNIDAD_FUNCIONAL_EDIT);
            this.canAdd = data.Result.some(x => x == MenuFuncionCodes.UNIDAD_FUNCIONAL_ADD);
            this.canView = data.Result.some(x => x == MenuFuncionCodes.UNIDAD_FUNCIONAL_LIST);
            this.canDelete = data.Result.some(x => x == MenuFuncionCodes.UNIDAD_FUNCIONAL_DELETE);

            this.loadView();
          }
        },
        (err: HttpErrorResponse) => {
          this.isSearching = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.onCancel();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.buildForm();

    this.getTipoUnidades();
    this.getComunidades();
    this.getMonedas();
    this.getConsorcios();

    this.loadEntity();
  }

  buildForm() {
    var cId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
    if (cId != null && cId.length > 0 && cId > 0)
      cId = Number(cId);

    this.formGroup = this.formBuilder.group({
      'Codigo': [null, [Validators.required, Validators.maxLength(100)]],
      'Numero': [null, Validators.required],
      'NumeroPartida': [null, Validators.maxLength(100)],
      'TipoUnidad': [null, Validators.required],
      'TipoUnidadId': [null],
      'ComunidadId': [null],
      'ConsorcioId': [cId],
      'NroPiso': [null],
      'MetrosCuadradosCubiertos': [null],
      'MetrosCuadradosDescubiertos': [null],
      'CantidadAmbientes': [null],
      'FechaEntrega': [null],
      'FechaEscrituracion': [null],
      'MonedaId': [null],
      'Precio': [null],
      'ValuacionFiscal': [null],
      'Observaciones': [null, Validators.maxLength(300)],
      'Activo': [true]
    });

    if (this.input.PreloadedData != null)
      this.formGroup.patchValue(this.input.PreloadedData);
  }

  getTipoUnidades() {
    var r = new SearchTipoUnidadRequest(null, null, true, "Nombre", null, null, null, true);
    this.isTipoUnidadSearching = true;

    this.tipoUnidadService.search(r).subscribe(data => {
      this.isTipoUnidadSearching = false;
      if (data != null) {
        this.tipoUnidadList = data?.result;
        this.updateTipoUnidadSelection();
      }
    },
    (err: HttpErrorResponse) => {
      this.isTipoUnidadSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  updateTipoUnidadSelection() {
    if (this.tipoUnidadList != null && this.item != null) {
      var tu = this.tipoUnidadList.find(f => f.Id == this.item.TipoUnidadId);

      if (tu != null) {
        this.formGroup.get("TipoUnidad")?.setValue(tu);
        this.onTipoUnidadSelect({ value: tu });
      }
    }
  }

  onTipoUnidadSelect(event: any) {
    if (event != null) {
      var selectedItem = event.value;
      this.formGroup.get("TipoUnidadId")?.setValue(selectedItem?.Id);

      if (selectedItem != null && selectedItem.Id > 0) {
        this.showComunidad = selectedItem.RequiereComunidad;
        if (selectedItem.RequiereComunidad) {
          this.formGroup.get("ConsorcioId")?.setValue(null);
        }
        else {
          this.formGroup.get("ComunidadId")?.setValue(null);
          this.formGroup.get("NumeroPartida")?.setValue(null);
        }
      }
      else
        this.showComunidad = false;
    }
  }

  getConsorcios() {
    var p = new SearchConsorcioRequest(null, null, true, "Nombre", null, null, null, null, null, true);
    this.isConsorcioSearching = true;

    this.consorcioService.search(p).subscribe(data => {
      this.isConsorcioSearching = false;
      if (data != null)
        this.consorcioList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isConsorcioSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getComunidades() {
    var cId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
    if (cId != null && cId.length > 0 && cId > 0)
      cId = Number(cId);

    var p = new SearchComunidadRequest(null, null, true, "Nombre", null, cId, null, null, null, true);
    this.isComunidadSearching = true;

    this.comunidadService.search(p).subscribe(data => {
      this.isComunidadSearching = false;
      if (data != null)
        this.comunidadList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isComunidadSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getMonedas() {
    var p = new SearchMonedaRequest(null, null, true, "Codigo", null, null, null, true);
    this.isMonedaSearching = true;

    this.monedaService.search(p).subscribe(data => {
      this.isMonedaSearching = false;
      if (data != null)
        this.monedaList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isMonedaSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  isProcessing() {
    return (this.isSearching || this.isSaving || this.isDeleting);
  }

  loadEntity() {
    if (this.input != null && this.input.Id > 0) {
      if (this.canView || this.canEdit) {
        this.isSearching = true;
        this.unidadFuncionalService.get(this.input.Id).subscribe(data => {
          this.isSearching = false;
          if (data != null && data.Success) {
            this.item = data.Result;
            this.showComunidad = this.item.TipoUnidadRequiereComunidad ?? false;

            if (this.item != null && this.item.Id > 0) {
              if (this.canEdit) {
                this.formGroup.patchValue(this.item);
                this.updateTipoUnidadSelection();

                if (this.item.FechaEntrega != null)
                  this.formGroup.get("FechaEntrega")?.setValue(this.datePipe.transform(this.item.FechaEntrega, "yyyy-MM-dd"));

                if (this.item.FechaEscrituracion != null)
                  this.formGroup.get("FechaEscrituracion")?.setValue(this.datePipe.transform(this.item.FechaEscrituracion, "yyyy-MM-dd"));
              }
            }
            else
              this.msgError = "No se encontró el item seleccionado.";
          }
          else
            this.msgError = "Ocurrió un error al intentar obtener los datos del item.";
        },
        (err: HttpErrorResponse) => {
          this.isSearching = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.onCancel();
      }
    }
    else {
      if (this.canAdd) {
        this.item = new UnidadFuncional(0, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, true, [], []);
        this.formGroup.patchValue(this.item);
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.onCancel();
      }
    }
  }

  onGuardar() {
    if (!this.formGroup.valid) {
      this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para continuar", "Error");
      return false;
    }

    var tu = this.formGroup.get("TipoUnidad")?.value;
    if (tu == null || tu.Id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un tipo de unidad para continuar con la operación", "Error");
      return false;
    }
    this.formGroup.get("TipoUnidadId")?.setValue(tu.Id);

    if (tu.RequiereComunidad) {
      var comuId = this.formGroup.get("ComunidadId")?.value;
      if (comuId == null || comuId <= 0) {
        this.sharedFunctions.showMessage("Por el tipo de unidad seleccionado debe seleccionar una comunidad para continuar con la operación", "Error");
        return false;
      }
    }
    else {
      var consorId = this.formGroup.get("ConsorcioId")?.value;
      if (consorId == null || consorId <= 0) {
        this.sharedFunctions.showMessage("Por el tipo de unidad seleccionado debe seleccionar un consorcio para continuar con la operación", "Error");
        return false;
      }
    }

    var r = new SaveUnidadFuncionalDto(0, null, null, null, null, null, null, null, null, null, null, null, null, null, null, true);

    r =
    {
      ...this.formGroup.value,
      ... {
        Id: (this.item?.Id ?? 0),
        Activo: this.item.Activo
      }
    };

    this.isSaving = true;
    this.unidadFuncionalService.save(r).subscribe(data => {
      this.isSaving = false;
      if (data != null && data.Success && data.Result != null && data.Result.Id > 0) {
        this.sharedFunctions.showMessage("Se guardaron correctamente los datos!", "Operación Exitosa!");
        var uf = data.Result;
        uf.TipoUnidadNombre = this.formGroup.get("TipoUnidad")?.value?.Nombre;

        var c = this.comunidadList.find(f => f.Id == this.formGroup.get("ComunidadId")?.value)
        if (c != null)
          uf.Comunidad = c?.Nombre;

        this.dialogRef.close(new DialogUnidadFuncionalGestionResponseDto(false, uf));
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isSaving = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onCancel() {
    this.dialogRef.close(new DialogUnidadFuncionalGestionResponseDto(true, null));
  }
}
